import axios from 'axios';
import { Urls } from './Constants';

export const GobikesApi = axios.create({
  baseURL: Urls.APP_BASE
});